import { ApPayeeDetail } from 'ap-openapi';
import { createValueProvider } from '../Context';

export const {
  SelectedValueProvider: ApPayeeSelectedValueProvider,
  useSelectedValue: useApPayeeSelectedValue,
  useSetSelectedValue: useSetApPayeeSelectedValue,
} = createValueProvider<ApPayeeDetail>();
